import { render, staticRenderFns } from "./link-cards.vue?vue&type=template&id=193c5b8f&scoped=true&"
var script = {}
import style0 from "./link-cards.vue?vue&type=style&index=0&id=193c5b8f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193c5b8f",
  null
  
)

export default component.exports